<div class="flex-container">
  <ng-container *ngIf="isCrack == 1">
    <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
        <thead>
          <tr style="text-align-last: center;">
            <th class="right-align schematicName">
              {{schematicDetails.Name}}
              <!-- <mat-icon  style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
              (click)="openSchematicWindow(schematicDetails)">add_location_alt</mat-icon> -->
              <mat-icon class="material-icons" (click)="fileInput.click()" style="cursor: pointer;">edit</mat-icon>
              <input style="display: none;" type="file"
                     #fileInput
                     (change)="onSelectPhoto($event, schematicDetails.Id)">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngIf="ImplementId > 0">
              <app-schematic-observation-points [ImplementId]="ImplementId" [SchematicOP]="ObservationPointDetails" [schematicData]="schematicDetails" [isCrack]="1" style="position: relative;"></app-schematic-observation-points>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="panel__content no-padding">
      <!-- Asset Details -->

      <table class="table table--striped table--full-width">

        <thead>
          <tr>
            <th style="padding: 16px 45px;text-align: left;">Component</th>
            <th style="padding: 16px 24px;text-align: left;">Observation Point</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">OP Type</th>
            <th class="column0">{{"History" | translate | async}}</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">% Worn</th>
            <th>Crack Length ({{userUOM}})</th>
            <th>Current Measure ({{userUOM}})</th>
            <th>Crack Severity</th>
            <th>Starting Dim. ({{userUOM}})</th>
            <th>Used Limit ({{userUOM}})</th>
            <th>Budget Life</th>
            <th> Life(hrs)</th>
            <th>Residual Life(hrs) 100%</th>
            <th>Residual Life(hrs) 120%</th>
            <th>Life Total Projected</th>
            <th style="text-align: center; padding: 16px 45px;text-align: center;">Install Date</th>
            <th>Part No.</th>
            <th>Manufacturer</th>
            <th>All Costs</th>
            <th matTooltip="Only availible for points that have not been inspected">Edit Points</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let OP of ObservationPointDetails">
            <tr *ngIf="!OP.IsCrackFixed">
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.ComponentName}}">
                {{OP.ComponentName}}
                <span style="font-style:italic" *ngIf="OP.isGETCritical==true">(G) </span>
                <span style="font-style:italic" *ngIf="OP.isCritical==true">(C) </span>

                <span style="font-style:italic" *ngIf="OP.isGETCritical==false && OP.isCritical==false ">(N) </span>

              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.Name}}">{{OP.Name}}</td>
              <td style="cursor: pointer;display: flex;" class="columncell" *ngIf="OP.Type == 'Crack'" title="{{OP.ObsQuestion}}">
                <ng-container>
                  <div [ngStyle]="{ 'background-color': OP.ColorCode || '#e4351d' }"
                       class="crack-status-badge" matTooltip="{{OP.CrackStatus}}">
                    {{OP.Type}}
                  </div>
                  <mat-icon class="material-icons" title="Change Repair status of crack" (click)="OpenCrackFixedDialog(OP)" style="cursor: pointer;">edit</mat-icon>
                </ng-container>

              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type != 'Crack'" title="{{OP.ObsQuestion}}"> {{OP.Type}}</td>
              <td style="cursor: pointer;" [title]="(OP.ImageHistoryAvailable ? 'Images History' : 'No Images History') | translate | async">
                <app-component-image-history-button [module]="ModuleType.GET"
                                                    [implementId]="ImplementId"
                                                    [componentId]="0"
                                                    [obsPointId]="OP.Id"
                                                    [imageHistoryAvailable]="OP.ImageHistoryAvailable">
                </app-component-image-history-button>
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                <ng-container *ngIf="OP.Eval == ''">
                  <div class="{{getEvalClass(OP.WornPct)}}">
                    {{OP.WornPct}}%
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==3">
                  <div class="{{getEvalClass2(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==4">
                  <div class="{{getEvalClass3(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
              </td>

              <td (click)="OpenNormalObsHistroyDialog(OP)" style="text-align: center;cursor: pointer;">{{OP.CrackLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CurrentLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" [matTooltip]="OP.CrackSeverity" matTooltipPosition="above">
                {{ OP.CrackSeverity?.length > 16 ? (OP.CrackSeverity | slice:0:16) + '...' : OP.CrackSeverity }}
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.StartingDim}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.MaximumLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CompBudgetLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.Life}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife120?.toFixed(0)}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.LifeTotalProjected}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.InstallDate}}</td>
              <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                  <ng-container>
                      <div >{{OP.InstallDate}}</div>
                  </ng-container>
              </td> -->
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.PartNo}}</div>
                </ng-container>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.Manufacturer}}</div>
                </ng-container>
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">$ {{OP.RepairCost}}</td>


              <!-- <ng-container *ngIf="OP.LastInspectionDate=='Never'"> -->
              <td>
                <div style="margin-left: 30px">
                  <i class="material-icons" style="cursor: pointer;"
                     (click)="openSchematicWindowforEdit(OP.Id, 2, schematicDetails)">edit</i>
                </div>
              </td>
              <!-- </ng-container> -->
            </tr>
          </ng-container>
        </tbody>
      </table>

      <!-- end Asset Details -->


    </div>
  </ng-container>

  <!-- Crack Registory -->
  <ng-container *ngIf="isCrack == 2 && FilerCrackObservationPointDetails!=null">
    <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
        <thead>
          <tr style="text-align-last: center;">
            <th class="right-align schematicName">
              {{schematicDetails.Name}}
              <!-- <mat-icon  style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
              (click)="openSchematicWindow(schematicDetails)">add_location_alt</mat-icon> -->
              <!-- <span style=" white-space: nowrap; "  *ngIf="sch.ObservationPoints.length >=0" >
                  <i  class="material-icons sc-icon" style="visibility: hidden;">delete</i></span> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <app-schematic-observation-points [SchematicOP]="ObservationPointDetails" [schematicData]="schematicDetails" [isCrack]="2" style="position: relative;"></app-schematic-observation-points>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">

        <thead>
          <tr>
            <th style="padding: 16px 45px;text-align: left;">Component</th>
            <th style="padding: 16px 24px;text-align: left;">Observation Point</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">OP Type</th>
            <th class="column0">{{"History" | translate | async}}</th>
            <th style="text-align: center; padding: 16px 24px;text-align: center;">% Worn</th>
            <th>Crack Length ({{userUOM}})</th>
            <th>Current Measure ({{userUOM}})</th>
            <th>Crack Severity </th>

            <th>Starting Dim. ({{userUOM}})</th>
            <th>Used Limit ({{userUOM}})</th>
            <th>Budget Life</th>
            <th> Life(hrs)</th>
            <th>Residual Life(hrs)</th>
            <th>Life Total Projected</th>
            <th style="text-align: center; padding: 16px 45px;text-align: center;">Install Date</th>
            <th>Part No.</th>
            <th>Manufacturer</th>
            <th>All Costs</th>
            <th>Comments</th>
            <th matTooltip="Only availible for points that have not been inspected">Edit Points</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let OP of ObservationPointDetails">
            <tr *ngIf="OP.Type == 'Crack'">
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.ComponentName}}">{{OP.ComponentName}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.Name}}">{{OP.Name}}</td>
              <td (click)="OpenCrackFixedDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type == 'Crack'">
                <ng-container>
                  <div [ngStyle]="{ 'background-color': OP.ColorCode || '#e4351d' }"
                       class="crack-status-badge" matTooltip="{{OP.CrackStatus}}">
                    {{OP.Type}}
                  </div>
                </ng-container>

              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type != 'Crack'"> {{OP.Type}}</td>
              <td style="cursor: pointer;" [title]="(OP.ImageHistoryAvailable ? 'Images History' : 'No Images History') | translate | async">
                <app-component-image-history-button [module]="ModuleType.GET"
                                                    [implementId]="ImplementId"
                                                    [componentId]="0"
                                                    [obsPointId]="OP.Id"
                                                    [imageHistoryAvailable]="OP.ImageHistoryAvailable">
                </app-component-image-history-button>
              </td>
              <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                  <ng-container *ngIf="OP.Eval == ''">
                      <div class="{{getEvalClass(OP.WornPct)}}">
                          {{OP.WornPct}}%
                      </div>
                  </ng-container>
                  <ng-container *ngIf="OP.Eval != ''">
                      <div class="{{getEvalClass2(OP.Eval)}}">
                          {{OP.Eval}}
                      </div>
                  </ng-container>
              </td> -->
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                <ng-container *ngIf="OP.Eval == ''">
                  <div class="{{getEvalClass(OP.WornPct)}}">
                    {{OP.WornPct}}%
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==3">
                  <div class="{{getEvalClass2(OP.Eval)}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
                <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==4">
                  <div class="{{getEvalClass2('U')}}">
                    {{OP.Eval}}
                  </div>
                </ng-container>
              </td>

              <td (click)="OpenNormalObsHistroyDialog(OP)" style="text-align: center;cursor: pointer;">{{OP.CrackLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CurrentLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" [matTooltip]="OP.CrackSeverity" matTooltipPosition="above">
                {{ OP.CrackSeverity?.length > 16 ? (OP.CrackSeverity | slice:0:16) + '...' : OP.CrackSeverity }}
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.StartingDim}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.MaximumLength}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.CompBudgetLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.Life}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.ResidualLife}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.LifeTotalProjected}}</td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">{{OP.InstallDate}}</td>
              <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                  <ng-container>
                      <div >{{OP.InstallDate}}</div>
                  </ng-container>
              </td> -->
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.PartNo}}</div>
                </ng-container>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">
                <ng-container>
                  <div>{{OP.Manufacturer}}</div>
                </ng-container>
              </td>
              <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell">$ {{OP.RepairCost}}</td>


              <td class="table__eval-cell">
                <ng-container *ngIf="OP.Crackcomment == null">
                  <i class="material-icons" style="cursor: pointer;" (click)="OpenCrackCommentDialog(OP)">chat_bubble</i>
                </ng-container>
                <ng-container *ngIf="OP.Crackcomment != null">
                  <i class="material-icons" style="cursor: pointer; color: green;" (click)="OpenCrackCommentDialog(OP)">chat_bubble</i>
                </ng-container>
              </td>


              <!-- <ng-container *ngIf="OP.LastInspectionDate=='Never'"> -->
              <td>
                <div style="margin-left: 30px">
                  <i class="material-icons" style="cursor: pointer;"
                     (click)="openSchematicWindowforEdit(OP.Id, 2)">edit</i>

                </div>
              </td>
              <!-- </ng-container> -->
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- end Crack Registory -->
</div>
